import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Modal } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { resendInvitation } from 'redux/colabsSlice';
import ButtonAccept from 'utils/buttons/ButtonAccept';
import ButtonClose from 'utils/buttons/ButtonClose';
import PropTypes from 'prop-types';
import ModalButtonsContainer from 'sites/common/ModalButtonsContainer';

const ResendModal = ({
  user,
  setShow,
  show,
  switchNewUser,
  setSwitchNewUser
}) => {
  const dispatch = useDispatch();
  const data = {
    email: user.email,
    dni: user.dni
  };

  const handleClose = () => setShow(false);

  const handleResend = () => {
    dispatch(resendInvitation(data));
    setSwitchNewUser(!switchNewUser);
    handleClose();
  };

  return (
    <>
      <Modal
        keyboard={true}
        show={show}
        onHide={handleClose}
        backdrop="static"
        centered
      >
        <Modal.Header closeButton>
          <FontAwesomeIcon
            icon="fa-rotate-right"
            title="Reenviar"
            size="1x"
            style={{ marginRight: 8, color: '#6b5eae' }}
          />

          <Modal.Title>Reenviar invitación</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <div className="mb-4">
            El usuario{' '}
            <b>
              {user.firstName} {user.lastName}
            </b>{' '}
            recibirá un nuevo email con la invitación y tendrá 24 horas para
            ingresar al enlace y registrar su contraseña.
            <br />
            <br />
            ¿Está seguro de confirmar esta acción?
          </div>

          <ModalButtonsContainer>
            <ButtonClose
              text="Cancelar"
              funcion={handleClose}
              variant="secondary"
            />

            <ButtonAccept text="Enviar" funcion={handleResend} />
          </ModalButtonsContainer>
        </Modal.Body>
      </Modal>
    </>
  );
};

ResendModal.propTypes = {
  user: PropTypes.object,
  setShow: PropTypes.func,
  show: PropTypes.bool,
  switchNewUser: PropTypes.bool,
  setSwitchNewUser: PropTypes.func
};

export default ResendModal;
